import { useMemo } from "react";
import { useSelector } from "react-redux";

import { getAppConfigShared } from "../../ducks/appConfig";
import { getProjectName } from "../../ducks/project/selectors";
import { getCurrentSharedMap } from "../../ducks/location/selectors";

export const useProjectName = (): string => {
  const shared = useSelector(getAppConfigShared);
  const sharedProjectName = useSelector(getCurrentSharedMap);
  const projectName = useSelector(getProjectName);

  return useMemo(() => (shared ? sharedProjectName : projectName), [shared, sharedProjectName, projectName]);
};
